import { useContext } from 'react';
import { Close, Refresh, RouteOutlined } from '@mui/icons-material';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

import { TargetNameAndDescription } from './TargetNameAndDescription';
import { useNavigate } from 'react-router';
import { MinimalTarget } from '@/generated/model';
import { ctxUser } from '@/contexts/UserContext';
import { useTranslation } from 'react-i18next';
import { NewFeatureBadge } from './NewFeatureBadge';

function FastAccessButtons({ target, isTracking }: { target: MinimalTarget; isTracking: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack direction="row" gap={1}>
      {isTracking && (
        <Tooltip title={t('tracking.fastAccessTooltip')} placement={isPhoneOrHighScreen() ? 'top' : 'right'}>
          <IconButton
            onClick={() =>
              navigate('/routes/select', {
                state: { target },
              })
            }
            size="small"
            color="primary"
            sx={{
              height: 'fit-content',
              background: 'var(--mui-palette-grey-200)',
              boxShadow: '0 0 10px rgb(2 136 209)',
            }}
          >
            <NewFeatureBadge releaseDate="2026-04-21">
              <RouteOutlined sx={{ transform: 'rotate(90deg)' }} />
            </NewFeatureBadge>
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}

export function HeaderNameAndIcons({
  target,
  onReload,
  onClose,
}: {
  target: MinimalTarget;
  onReload?: () => void;
  onClose: () => void;
}) {
  const userCtx = useContext(ctxUser);
  const isTracking = onReload !== undefined;

  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Stack direction="row" gap={5} alignItems="center" sx={isPhoneOrHighScreen() ? { pl: 1, pt: '4px' } : {}}>
        <TargetNameAndDescription
          targetName={target.name}
          targetDescription={target.description}
          styleClassName={'target-name-and-description-header'}
        />
        {!userCtx?.isToken() && <FastAccessButtons target={target} isTracking={isTracking} />}
      </Stack>
      <span>
        {onReload !== undefined && (
          <IconButton
            color="primary"
            onClick={onReload}
            sx={{ alignSelf: 'start' }}
            data-qa-element-id="popup_refresh_button"
          >
            <Refresh />
          </IconButton>
        )}
        <IconButton
          color="primary"
          onClick={onClose}
          sx={{ alignSelf: 'start' }}
          data-qa-element-id="popup_close_button"
        >
          <Close />
        </IconButton>
      </span>
    </div>
  );
}
